// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
    background-color: white;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.login-logo {
    margin-top: 20px;
    margin-bottom: 20px;
    object-fit: contain;
    width: 100px;
}

.login-container {
    width: 300px;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 20px;
    background-color: white;
    text-align: center;
}

.login-container h1 {
    font-weight: 500;
    margin-bottom: 20px;
}

.login-container h5 {
    margin-bottom: 5px;
    text-align: left;
}

.login-container input {
    height: 40px;
    margin-bottom: 10px;
    background-color: #f8f8f8;
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0 10px;
}

.login-container form {
    display: flex;
    flex-direction: column;
}

.login-signInButton {
    background: #10a37f;
    border-radius: 4px;
    width: 100%;
    height: 40px;
    border: none;
    color: white;
    font-weight: bold;
    margin-top: 10px;
    cursor: pointer;
    transition: ease 0.25s all;
}

.login-signInButton:hover {
    background: #0e8f6f;
}

.login-google-button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: 100%;
    height: 40px;
    border: 1px solid #ccc;
    margin-top: 10px;
    background-color: white;
    cursor: pointer;
    font-weight: normal;
    font-size: 14px;
    color: #757575;
    transition: background-color 0.3s ease;
    padding: 0;
    text-transform: none;
    font-family: Arial, sans-serif;
}

.login-google-button:hover {
    background-color: #f1f1f1;
}

.icon-google {
    width: 18px;
    height: 18px;
    margin-right: 8px;
}

.google_text {
    display: inline-block;
    line-height: 40px;
}


.login-registerButton {
    border-radius: 4px;
    width: 100%;
    height: 40px;
    border: 1px solid #ccc;
    margin-top: 10px;
    background-color: white;
    cursor: pointer;
    font-weight: bold;
    transition: ease 0.25s all;
}

.login-registerButton:hover {
    background: #f1f1f1;
}

.login-api {
    width: 300px !important;
}

.login-api>div {
    width: 100% !important;
}

hr {
    border: none;
    border-top: 1px solid #c2c8d0;
    margin: 20px 0;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,sCAAsC;IACtC,UAAU;IACV,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,WAAW;AACf","sourcesContent":[".login {\n    background-color: white;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.login-logo {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    object-fit: contain;\n    width: 100px;\n}\n\n.login-container {\n    width: 300px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    background-color: white;\n    text-align: center;\n}\n\n.login-container h1 {\n    font-weight: 500;\n    margin-bottom: 20px;\n}\n\n.login-container h5 {\n    margin-bottom: 5px;\n    text-align: left;\n}\n\n.login-container input {\n    height: 40px;\n    margin-bottom: 10px;\n    background-color: #f8f8f8;\n    width: 100%;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    padding: 0 10px;\n}\n\n.login-container form {\n    display: flex;\n    flex-direction: column;\n}\n\n.login-signInButton {\n    background: #10a37f;\n    border-radius: 4px;\n    width: 100%;\n    height: 40px;\n    border: none;\n    color: white;\n    font-weight: bold;\n    margin-top: 10px;\n    cursor: pointer;\n    transition: ease 0.25s all;\n}\n\n.login-signInButton:hover {\n    background: #0e8f6f;\n}\n\n.login-google-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    width: 100%;\n    height: 40px;\n    border: 1px solid #ccc;\n    margin-top: 10px;\n    background-color: white;\n    cursor: pointer;\n    font-weight: normal;\n    font-size: 14px;\n    color: #757575;\n    transition: background-color 0.3s ease;\n    padding: 0;\n    text-transform: none;\n    font-family: Arial, sans-serif;\n}\n\n.login-google-button:hover {\n    background-color: #f1f1f1;\n}\n\n.icon-google {\n    width: 18px;\n    height: 18px;\n    margin-right: 8px;\n}\n\n.google_text {\n    display: inline-block;\n    line-height: 40px;\n}\n\n\n.login-registerButton {\n    border-radius: 4px;\n    width: 100%;\n    height: 40px;\n    border: 1px solid #ccc;\n    margin-top: 10px;\n    background-color: white;\n    cursor: pointer;\n    font-weight: bold;\n    transition: ease 0.25s all;\n}\n\n.login-registerButton:hover {\n    background: #f1f1f1;\n}\n\n.login-api {\n    width: 300px !important;\n}\n\n.login-api>div {\n    width: 100% !important;\n}\n\nhr {\n    border: none;\n    border-top: 1px solid #c2c8d0;\n    margin: 20px 0;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
